import { render } from "./ClaimsList.vue?vue&type=template&id=53d9c17a&bindings={}"
import script from "./ClaimsList.vue?vue&type=script&lang=ts"
export * from "./ClaimsList.vue?vue&type=script&lang=ts"
script.render = render

export default script